import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PortalAuthProvider, RequirePortalAuth } from "@/lib/auth";
import { HomePage } from "@/pages/HomePage";
import { LoginPage } from "@/pages/LoginPage";

export default function App() {
  return (
    <BrowserRouter>
      <PortalAuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequirePortalAuth>
                <HomePage />
              </RequirePortalAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PortalAuthProvider>
    </BrowserRouter>
  );
}
